import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import {
	formatDateRange,
	getLozengeContent,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/sprints';
import { SprintIcon } from '@atlassian/jira-portfolio-3-portfolio/src/common/icons';
import { isDefined } from '@atlassian/jira-portfolio-3-portfolio/src/common/ramda';
import { SPRINT_STATES } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant';
import GroupContainer from '../container';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types';

function Sprint({ height, width, position, sprint }: Props) {
	const intl = useIntl();
	const endDate = sprint.completeDate || sprint.endDate;
	const startDate = sprint.startDate;
	const date =
		isDefined(startDate) && isDefined(endDate) ? (
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			<div className={styles.sprintDate}>{formatDateRange(intl, startDate, endDate)}</div>
		) : (
			''
		);
	const state = getLozengeContent(intl)({
		sprint,
		isFutureProjectedSprint: sprint.id === SPRINT_STATES.FUTURE,
	});

	return (
		<GroupContainer
			{...{ height, width, position }}
			title={sprint.title}
			toolTipContent={
				<>
					{date}
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
					<div className={styles.sprintDate}>{state}</div>
				</>
			}
			tooltipKey={sprint.id}
			testId={`portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.sprint-group-${sprint.id}`}
			iconBefore={<SprintIcon />}
		/>
	);
}

export default Sprint;
